import { MetricsKind } from "helpers/metrics/types";
import { RowComputeParams } from "./types";
import { sum } from "./sum";
import { safeParseFloat } from "lib/number";

export const AUR = (params: RowComputeParams) => {
    const { mainRowNodes, getterParams, gridViewRef } = params;

    const unitsValues = gridViewRef.current.getMetricValuesForRows(
        getterParams.column.getColId(),
        MetricsKind.UNITS,
        mainRowNodes
    );
    const retailValues = gridViewRef.current.getMetricValuesForRows(
        getterParams.column.getColId(),
        MetricsKind.TOTAL_RETAIL,
        mainRowNodes
    );

    const totalUnits = sum(unitsValues);
    const totalRetail = sum(retailValues);

    return safeParseFloat(totalRetail / totalUnits, 0);
};
